'use client';

import { Loader2 } from 'lucide-react';

export function ReportPendingBanner() {
	return (
		<div className="flex items-center gap-3 rounded-2xl border border-gray-4 bg-white px-4 py-3">
			<Loader2
				size={18}
				strokeWidth={2}
				className="shrink-0 animate-spin text-gray-3"
			/>
			<span className="text-base text-gray-3">
				Подождите, формируется отчёт…
			</span>
		</div>
	);
}
